import { useContext, useEffect, useState } from 'react';
import { ProgramContext } from '../../context/ProgramsContext';
import { ChevronDown } from 'lucide-react';
import toast from 'react-hot-toast';

const ExerciseLibraryModal = ({ onClose, onAdd, selectedExercisesList }) => {
  const { mockApi, exerciseTemplates } = useContext(ProgramContext);

  const [library, setLibrary] = useState([]);
  const [filters, setFilters] = useState({
    subtype: 'All',
    focus: 'All',
    position: 'All',
    phase: 'All',
    search: '',
  });
  const [selectedExercises, setSelectedExercises] = useState({});
  const [subtypes, setSubtypes] = useState([]);
  const [focuses, setFocuses] = useState([]);
  const [lockedExercises, setLockedExercises] = useState({})
  const [selectedExercisesArray, setSelectedExercisesArray] = useState([])
  const [firstPotraitSelected, setFirstPotraitSelected] = useState(false);
  const [firstLandscapeSelected, setFirstLandscapeSelected] = useState(false);
  const [secondPotraitSelected, setSecondPotraitSelected] = useState(false);
  const [secondLandscapeSelected, setSecondLandscapeSelected] = useState(false);

  useEffect(() => {
    if (selectedExercisesArray?.length > 0) {
      if (selectedExercisesArray[0]?.is_portrait === 1) {
        setFirstPotraitSelected(true)
        setFirstLandscapeSelected(false)
      } else if (selectedExercisesArray[0]?.is_portrait === 0) {
        setFirstLandscapeSelected(true)
        setFirstPotraitSelected(false)
      }
    } else {
      setFirstPotraitSelected(false)
      setFirstLandscapeSelected(false)
    }
  }, [selectedExercisesArray])

  useEffect(() => {
    if (selectedExercisesArray?.length > 0) {
      if (firstPotraitSelected) {
        const landscapeSelected = selectedExercisesArray?.some((e) => e?.is_portrait === 0)
        setSecondLandscapeSelected(landscapeSelected)
      } else if (firstLandscapeSelected) {
        const potraitSelected = selectedExercisesArray?.some((e) => e?.is_portrait === 1)
        setSecondPotraitSelected(potraitSelected)
      }
    } else {
      setSecondLandscapeSelected(false)
      setSecondPotraitSelected(false)
    }
  }, [firstPotraitSelected, firstLandscapeSelected, selectedExercisesArray])

  useEffect(() => {
    toast.dismiss()
    if (secondPotraitSelected === true) {
      toast("You can select only potrait exercises for this session")
    } else if (secondLandscapeSelected === true) {
      toast("You can select only landscape exercises for this session")
    }
  }, [secondLandscapeSelected, secondPotraitSelected])

  useEffect(() => {
    console.log("exerciseTemplates", exerciseTemplates)
    if (selectedExercisesList?.length > 0) {
      const uniqueIds = {};
      selectedExercisesList.forEach(item => {
        const itemId = exerciseTemplates?.find((e) => e?.name === item?.name)?.exerciseId
        uniqueIds[itemId] = true;
      });
      setSelectedExercisesArray(selectedExercisesList?.map((e) => ({...e, isOld: true})))
      setLockedExercises(uniqueIds)
    }
  }, [selectedExercisesList])

  useEffect(() => {
    mockApi.fetchExerciseLibrary().then(setLibrary);
  }, []);

  useEffect(() => {
    if (exerciseTemplates?.length > 0) {
      const uniqueSubtypes = Array.from(
        new Set(
          exerciseTemplates.map(
            (ex) => ex.exercise_data?.sub_problem_name?.trim()
          )
        )
      ).filter(Boolean);
      setSubtypes(uniqueSubtypes);

      const uniqueFocuses = Array.from(
        new Set(
          exerciseTemplates.map(
            (ex) => ex.exercise_data?.exercise_type?.trim()
          )
        )
      ).filter(Boolean);
      setFocuses(uniqueFocuses);
    }
  }, [exerciseTemplates]);

  const handleSelect = (exId, exercise) => {
    setSelectedExercises((prev) => ({ ...prev, [exId]: !prev[exId] }));
    setSelectedExercisesArray((prev) => {
      const exists = prev.find((e) => e.exerciseId === exId);

      if (exists) {
        return prev.filter((e) => e.exerciseId !== exId);
      } else {
        return [...prev, exercise];
      }
    });
  }

  const filteredLibrary = library?.filter((ex) => {
    const matchesSubtype =
      filters.subtype === 'All' ||
      ex.exercise_data?.sub_problem_name === filters.subtype;
    const matchesFocus =
      filters.focus === 'All' ||
      ex.exercise_data?.exercise_type === filters.focus;
    const matchesPosition =
      filters.position === 'All' || ex.position === filters.position;
    const matchesPhase =
      filters.phase === 'All' ||
      ex.exercise_data?.exercise_level === filters.phase;
    const matchesSearch =
      !filters.search ||
      ex.name.toLowerCase().includes(filters.search.toLowerCase());

    return (
      matchesSubtype &&
      matchesFocus &&
      matchesPosition &&
      matchesPhase &&
      matchesSearch
    );
  });

  const handleAdd = () => {
    // const toAdd = library
    //   .filter((ex) => selectedExercises[ex.id])
    //   .map((ex) => ({
    //     ...ex,
    //     sets: ex.sets ?? 1, // ensure sets exist
    //     equipment_id: ex?.exercise_data?.equipment_id,
    //     equipment_name: ex?.exercise_data?.equipment_name
    //   }));
    const toAdd = selectedExercisesArray?.filter((e) => !e?.isOld)
      ?.map((selectedEx) => {
        const match = library.find((libEx) => libEx.id === selectedEx.exerciseId);
        if (!match) return null;
        return {
          ...match,
          sets: match.sets ?? 1, // ensure sets exist
          equipment_id: match.exercise_data?.equipment_id,
          equipment_name: match.exercise_data?.equipment_name,
        };
      })
      .filter(Boolean);
    onAdd(toAdd);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-[70] animate-fade-in-up">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[95vw] sm:max-w-6xl p-6 transform transition-all flex flex-col max-h-[90vh]">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">Exercise Library</h2>

        {/* Filters */}

        <div className='flex flex-row w-full justify-end mb-4 '>
          <input
            type="text"
            placeholder="Search exercise..."
            value={filters.search}
            onChange={(e) =>
              setFilters((f) => ({ ...f, search: e.target.value }))
            }
            className="w-full sm:max-w-[350px] border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#166273]/30 border-gray-300"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
          {/* Subtypes */}
          <div className="relative">
            <select
              value={filters.subtype}
              onChange={(e) =>
                setFilters((f) => ({ ...f, subtype: e.target.value }))
              }
              className="border rounded-md px-3 py-2 appearance-none w-full focus:outline-none focus:ring-2 focus:ring-[#166273]/30 border-gray-300"
            >
              <option value="All">All Subtypes</option>
              {subtypes.map((type) => (
                <option key={type}>{type}</option>
              ))}
            </select>
            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" size={18} />
          </div>

          {/* Focus */}
          <div className="relative">
            <select
              value={filters.focus}
              onChange={(e) =>
                setFilters((f) => ({ ...f, focus: e.target.value }))
              }
              className="border rounded-md px-3 py-2 appearance-none w-full focus:outline-none focus:ring-2 focus:ring-[#166273]/30 border-gray-300"
            >
              <option value="All">All Focuses</option>
              {focuses.map((type) => (
                <option key={type}>{type}</option>
              ))}
            </select>
            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" size={18} />
          </div>

          {/* Position */}
          <div className="relative">
            <select
              value={filters.position}
              onChange={(e) =>
                setFilters((f) => ({ ...f, position: e.target.value }))
              }
              className="border rounded-md px-3 py-2 appearance-none w-full focus:outline-none focus:ring-2 focus:ring-[#166273]/30 border-gray-300"
            >
              <option value="All">All Position Categories</option>
              <option>Floor</option>
              <option>Seated</option>
              <option>Standing</option>
            </select>
            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" size={18} />
          </div>

          {/* Phase */}
          <div className="relative">
            <select
              value={filters.phase}
              onChange={(e) =>
                setFilters((f) => ({ ...f, phase: e.target.value }))
              }
              className="border rounded-md px-3 py-2 appearance-none w-full focus:outline-none focus:ring-2 focus:ring-[#166273]/30 border-gray-300"
            >
              <option value="All">All Phases</option>
              <option value="Level 1">Phase 1</option>
              <option value="Level 2">Phase 2</option>
              <option value="Level 3">Phase 3</option>
              <option value="Level 4">Phase 4</option>
            </select>
            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" size={18} />
          </div>
        </div>

        {/* Table */}
        <div className="flex-grow overflow-y-auto">
          <table className="w-full text-left border-collapse relative">
            <thead>
              <tr className="border-b bg-gray-50 text-gray-700 text-sm sticky top-0 z-10">
                <th className="p-2 font-medium">Select</th>
                <th className="p-2 font-medium">Exercise Name</th>
                <th className="p-2 font-medium">Position Category</th>
                <th className="p-2 font-medium">To Camera</th>
                <th className="p-2 font-medium">Body Position</th>
                <th className="p-2 font-medium">Limb</th>
                <th className="p-2 font-medium">Sets</th>
              </tr>
            </thead>
            <tbody>
              {filteredLibrary
                // ?.filter((e) => isPotraitSelected === true ? e?.is_portrait === 1 : isPotraitSelected === false ? e?.is_portrait === 0 : e)
                ?.sort((a, b) => {
                  const positionOrder = ['Floor', 'Standing', 'Seated'];
                  const posA = positionOrder.indexOf(a.position || '');
                  const posB = positionOrder.indexOf(b.position || '');
                  return posA - posB;
                })
                ?.map((ex) => {

                  let isDisabled = false

                  if (ex?.is_portrait === 0 && secondPotraitSelected === true) {
                    isDisabled = true
                  }
                  if (ex?.is_portrait === 1 && secondLandscapeSelected === true) {
                    isDisabled = true
                  }

                  return (
                    <tr
                      key={ex.id}
                      onClick={() => {
                        if (!!lockedExercises[ex.id] || isDisabled) { return; }
                        handleSelect(ex.id, ex)
                      }}
                      className={`border-b hover:bg-gray-100 text-sm cursor-pointer ${selectedExercises[ex.id] ? 'bg-gray-100' : ''
                        } ${(lockedExercises[ex.id] || isDisabled) ? "opacity-[0.5]" : ""}`}
                    >
                      <td className="p-2">
                        <input
                          type="checkbox"
                          checked={!!selectedExercises[ex.id] || !!lockedExercises[ex.id]}
                          className="h-4 w-4 text-[#166273] border-gray-300 rounded pointer-events-none"
                          onChange={(e) => e.preventDefault()}
                        />
                      </td>
                      <td className="p-2 font-semibold text-gray-800">{ex.name}</td>
                      <td className="p-2">{ex.position}</td>
                      <td className="p-2">{ex.toCamera}</td>
                      <td className="p-2">{ex.bodyPosition}</td>
                      <td className="p-2">{ex.limb}</td>
                      <td className="p-2">{ex.sets ?? 1}</td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="mt-6 pt-4 border-t flex flex-col sm:flex-row justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 font-semibold rounded-lg border border-gray-300 hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleAdd}
            disabled={
              Object.values(selectedExercises)?.length === 0 ||
              Object.values(selectedExercises)?.every(e => e === false)
            }
            className="px-4 py-2 bg-[#166273] text-white font-semibold rounded-lg shadow-md hover:bg-[#166273]/90 transition disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            Add Selected Exercises
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExerciseLibraryModal;
